import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';

import { SearchPageQueryInputComponent, ViewType } from '@recruitee/search-ui';
import { IconName } from '@recruitee/user-interface';

import { injectInfoFields } from './info-fields';

/*
  eslint-disable
  @angular-eslint/no-inputs-metadata-property,
  @typescript-eslint/consistent-type-assertions,
*/

@Component({
  selector: 'rt-views-candidate-search',
  template: `
    <rt-search-page-query-input
      [value]="searchControl.value || ''"
      [view]="ViewType.Candidates"
      [infoFields]="infoFields"
      [customPlaceholderKey]="'app.common.search'"
      [isSmall]="true"
      [readMoreLink]="'app.support_resources.search_with_boolean'"
      (valueChange)="searchControl.setValue($event)"
      class="search"
    />
  `,
  imports: [SearchPageQueryInputComponent],
  styleUrl: './candidates-search.component.less',
  inputs: CandidateSearchComponent.NgInputs,
})
export class CandidateSearchComponent {
  public static NgInputs = ['searchControl' as const];

  protected readonly ViewType = ViewType;

  public searchControl: FormControl<string | null>;

  public infoFields: Array<{ icon: IconName; label: string }> = injectInfoFields();
}
